(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-become"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. Everything else is CSS. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsBecomeBound === '1') return;
    section.dataset.sgsBecomeBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-become]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-bundles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('[data-sgs-bundles]').forEach(function (section) {
      if (section.dataset.sgsBundlesBound) return;
      section.dataset.sgsBundlesBound = '1';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      section.setAttribute('data-reveal', '');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -12% 0px' }
      );

      observer.observe(section);
    });

    document.querySelectorAll('[data-sgs-stepper]').forEach(function (stepper) {
      if (stepper.dataset.sgsStepperBound) return;
      stepper.dataset.sgsStepperBound = '1';

      var input = stepper.querySelector('[data-sgs-qty]');
      if (!input) return;

      stepper.querySelectorAll('[data-sgs-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var current = parseInt(input.value, 10);
          if (isNaN(current)) current = 1;
          var next = current + parseInt(button.dataset.sgsStep, 10);
          input.value = next < 1 ? 1 : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // Typing a 0, a minus sign or nothing at all must not post a broken
      // quantity to /cart/add.
      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        input.value = isNaN(value) || value < 1 ? 1 : value;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-courses"] && !Shopify.designMode) return;
  try {
    
/* Reveal only — the buying is Dawn's <product-form>, untouched. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsCoursesBound === '1') return;
    section.dataset.sgsCoursesBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-courses]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.sgsDetailBound === '1') return;
    section.dataset.sgsDetailBound = '1';

    var tabs = section.querySelectorAll('[data-tab]');
    var panels = section.querySelectorAll('[data-panel]');
    if (!tabs.length) return;

    /* So agora e que se pode esconder o que nao esta escolhido: ate aqui a
       pagina funciona sem script nenhum. */
    section.setAttribute('data-tabs', '');

    function show(index) {
      tabs.forEach(function (tab) {
        var on = tab.dataset.tab === index;
        tab.setAttribute('aria-expanded', on ? 'true' : 'false');
        tab.parentElement.parentElement.classList.toggle('is-on', on);
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-on', panel.dataset.panel === index);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        show(tab.dataset.tab);
      });
    });

    show('0');
  }

  function boot() {
    document.querySelectorAll('[data-sgs-detail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-elective-pack"] && !Shopify.designMode) return;
  try {
    
class SgsElectivePack {
  constructor(root) {
    this.root = root;
    this.money = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: root.dataset.currency || 'USD',
    });

    this.tiers = Array.from(root.querySelectorAll('[data-tier]')).map((el) => ({
      el,
      count: parseInt(el.dataset.count, 10) || 0,
      pct: parseFloat(el.dataset.pct) || 0,
      code: el.dataset.code || '',
    }));
    this.tiers.sort((a, b) => a.count - b.count);

    this.rows = Array.from(root.querySelectorAll('.sgs-epack__row'));
    this.picks = Array.from(root.querySelectorAll('[data-pick]'));
    this.find = root.querySelector('[data-sgs-find]');
    this.list = root.querySelector('[data-sgs-list]');
    this.empty = root.querySelector('[data-sgs-empty]');
    this.count = root.querySelector('[data-sgs-count]');
    this.line = root.querySelector('[data-sgs-line]');
    this.total = root.querySelector('[data-sgs-total]');
    this.save = root.querySelector('[data-sgs-save]');
    this.items = root.querySelector('[data-sgs-items]');
    this.ret = root.querySelector('[data-sgs-return]');
    this.cta = root.querySelector('[data-sgs-cta]');

    if (!this.tiers.length || !this.picks.length) return;

    this.tier = this.tiers[0];
    this.tiers.forEach((t) => {
      t.el.addEventListener('click', () => {
        this.tier = t;
        this.trim();
        this.render();
      });
    });

    this.picks.forEach((box) => box.addEventListener('change', () => this.onPick(box)));
    if (this.find) this.find.addEventListener('input', () => this.filter());

    this.seed();
    this.render();
  }

  /* Quem chegou a esta pagina veio por causa desta electiva: entra marcada e
     sobe ao topo da lista. */
  seed() {
    const here = this.root.dataset.here;
    if (!here) return;

    const row = this.rows.find((r) => r.dataset.handle === here);
    if (!row || !this.list) return;

    this.list.insertBefore(row, this.list.firstChild);
    const box = row.querySelector('[data-pick]');
    if (box) box.checked = true;
  }

  chosen() {
    return this.picks.filter((box) => box.checked);
  }

  /* Trocar para um pack mais pequeno nao pode deixar escolhas a mais no
     carrinho: as ultimas caem. */
  trim() {
    const over = this.chosen().length - this.tier.count;
    if (over <= 0) return;
    this.chosen().slice(-over).forEach((box) => {
      box.checked = false;
    });
  }

  onPick(box) {
    if (box.checked && this.chosen().length > this.tier.count) {
      box.checked = false;
    }
    this.render();
  }

  filter() {
    const q = (this.find.value || '').trim().toLowerCase();
    let shown = 0;

    this.rows.forEach((row) => {
      const box = row.querySelector('[data-pick]');
      /* O que ja esta escolhido nunca desaparece por causa de uma procura. */
      const keep = !q || (row.dataset.name || '').toLowerCase().includes(q) || (box && box.checked);
      row.hidden = !keep;
      if (keep) shown += 1;
    });

    if (this.empty) this.empty.hidden = shown > 0;
  }

  render() {
    const chosen = this.chosen();
    const need = this.tier.count;

    this.tiers.forEach((t) => {
      const on = t === this.tier;
      t.el.classList.toggle('is-on', on);
      t.el.setAttribute('aria-pressed', String(on));
    });

    const full = chosen.length >= need;
    this.rows.forEach((row) => {
      const box = row.querySelector('[data-pick]');
      const on = box && box.checked;
      row.classList.toggle('is-on', !!on);
      row.classList.toggle('is-off', full && !on);
    });

    if (this.count) this.count.textContent = chosen.length + ' of ' + need + ' chosen';

    const gross = chosen.reduce((sum, box) => sum + (parseInt(box.dataset.price, 10) || 0), 0);
    const pct = full ? this.tier.pct : 0;
    const net = Math.round(gross * (1 - pct / 100));

    if (this.line) {
      this.line.textContent = full
        ? chosen.length + ' electives  -  ' + this.tier.pct + '% off'
        : 'Pick ' + (need - chosen.length) + ' more to complete the pack';
    }

    if (this.total) this.total.textContent = gross ? this.money.format(net / 100) : '';

    if (this.save) {
      const saved = gross - net;
      this.save.hidden = saved <= 0;
      this.save.textContent = 'You save ' + this.money.format(saved / 100);
    }

    if (this.cta) this.cta.disabled = !full;

    /* Um pack sao N linhas de quantidade 1, e nao N de uma linha. O formato
       `items[i][id]` e o que o /cart/add aceita num formulario normal. */
    if (this.items) {
      this.items.textContent = '';
      chosen.forEach((box, i) => {
        const id = document.createElement('input');
        id.type = 'hidden';
        id.name = 'items[' + i + '][id]';
        id.value = box.value;
        this.items.appendChild(id);

        const qty = document.createElement('input');
        qty.type = 'hidden';
        qty.name = 'items[' + i + '][quantity]';
        qty.value = '1';
        this.items.appendChild(qty);
      });
    }

    if (this.ret) {
      this.ret.value = full && this.tier.code
        ? '/discount/' + encodeURIComponent(this.tier.code) + '?redirect=/checkout'
        : '/checkout';
    }
  }
}

document.querySelectorAll('[data-sgs-epack]').forEach((root) => new SgsElectivePack(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-electives"] && !Shopify.designMode) return;
  try {
    
/*
 * The rail: drag with the mouse, arrows on the wide screens, and nothing
 * at all on touch — a finger already knows what to do with this, and any
 * script that intervenes there only makes it worse.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRail(section) {
    var rail = section.querySelector('[data-sgs-elec-rail]');
    if (!rail) return;

    var arrows = section.querySelector('[data-sgs-elec-arrows]');
    var buttons = arrows ? Array.prototype.slice.call(arrows.querySelectorAll('button')) : [];

    function scrollable() {
      return rail.scrollWidth - rail.clientWidth > 4;
    }

    function sync() {
      if (!arrows) return;
      arrows.hidden = !scrollable();
      var max = rail.scrollWidth - rail.clientWidth;
      buttons.forEach(function (b) {
        var dir = Number(b.dataset.dir);
        var atEnd = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
        if (atEnd) {
          b.setAttribute('disabled', '');
        } else {
          b.removeAttribute('disabled');
        }
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = rail.querySelector('.sgs-elec__card');
        var step = card ? card.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
        rail.scrollBy({
          left: step * Number(b.dataset.dir) * 2,
          behavior: reduce.matches ? 'auto' : 'smooth',
        });
      });
    });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /*
     * Drag, for the mouse only. A pointerdown from a finger is left alone
     * so the browser keeps its own momentum scrolling, which is better
     * than anything reimplemented here.
     */
    var down = false;
    var moved = 0;
    var startX = 0;
    var startLeft = 0;

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!scrollable()) return;
      down = true;
      moved = 0;
      startX = event.clientX;
      startLeft = rail.scrollLeft;
      rail.classList.add('is-dragging');
    });

    rail.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      rail.scrollLeft = startLeft - dx;
      if (moved > 4) event.preventDefault();
    });

    function release() {
      if (!down) return;
      down = false;
      rail.classList.remove('is-dragging');
      sync();
    }

    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);

    /* A drag that ends on a card must not also open that card. */
    rail.addEventListener(
      'click',
      function (event) {
        if (moved > 6) {
          event.preventDefault();
          event.stopPropagation();
          moved = 0;
        }
      },
      true
    );
  }

  function initReveal(section) {
    if (reduce.matches) return;
    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    io.observe(section);
  }

  function init(section) {
    if (section.dataset.sgsElecBound === '1') return;
    section.dataset.sgsElecBound = '1';
    initRail(section);
    initReveal(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-elec]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-faq"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. The accordion itself is <details>, so opening, closing,
   keyboard and the single-open rule are the browser's job, not ours. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsFaqBound === '1') return;
    section.dataset.sgsFaqBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-header"]) return;
  try {
    
class SgsHeader {
  constructor(root) {
    this.root = root;
    this.panel = root.querySelector('[data-sgs-panel]');
    this.burger = root.querySelector('[data-sgs-burger]');
    this.nav = root.querySelector('.sgs-header__nav');
    this.sections = Array.from(document.querySelectorAll('[data-nav]'));
    this.frame = 0;

    /* Um ecra sem rato nao tem hover. Tudo o que abre por hover — e o
       atalho que manda o clique no pai direito para a pagina — pergunta
       primeiro a este. */
    this.hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.update = this.update.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.measure = this.measure.bind(this);

    this.update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);

    if (this.burger && this.panel) this.setupPanel();
    this.setupDropdowns();

    this.measure();
    window.addEventListener('resize', this.measure);
    /* A largura das palavras muda quando a fonte real acaba de carregar. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.measure).catch(() => {});
    }
  }

  onScroll() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(this.update);
  }

  update() {
    this.root.classList.toggle('is-scrolled', window.scrollY > 12);

    const probe = this.root.offsetHeight * 0.5;
    let theme = 'light';
    for (const section of this.sections) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= probe && rect.bottom > probe) {
        theme = section.dataset.nav || 'light';
        break;
      }
    }
    this.root.classList.toggle('is-light', theme === 'light');
  }

  /*
   * A nav cabe, ou nao cabe. Mede-se o conteudo contra a coluna que lhe
   * toca: se transbordar, o cabecalho passa a `is-crowded` e devolve o
   * burger. E isto que impede a sobreposicao em qualquer largura, seja
   * qual for a fonte que o browser carregou ou o comprimento que o cliente
   * decida dar a um item do menu.
   */
  measure() {
    if (!this.nav) return;

    this.root.classList.remove('is-crowded');
    if (window.getComputedStyle(this.nav).display === 'none') return;

    if (this.nav.scrollWidth > this.nav.clientWidth + 1) {
      this.root.classList.add('is-crowded');
    } else {
      this.closePanel();
    }
  }

  closePanel() {
    if (!this.burger || !this.panel) return;
    this.burger.setAttribute('aria-expanded', 'false');
    this.panel.hidden = true;
  }

  setupPanel() {
    this.burger.addEventListener('click', () => {
      const open = this.burger.getAttribute('aria-expanded') === 'true';
      this.burger.setAttribute('aria-expanded', String(!open));
      this.panel.hidden = open;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closePanel();
    });
  }

  setupDropdowns() {
    const groups = Array.from(this.root.querySelectorAll('[data-sgs-menu-group]'));
    if (!groups.length) return;

    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        groups.forEach((other) => {
          if (other !== group) other.open = false;
        });
      });

      /*
       * Opening is instant, closing is not. The panel hangs below the word
       * with a gap, and a pointer travelling to a link at the far edge of
       * the panel cuts a diagonal that leaves the group for a few frames.
       * The strip drawn under the panel in CSS covers the straight path;
       * this delay covers the diagonal. Both, because either alone still
       * loses the visitor now and then.
       */
      let shut;

      group.addEventListener('mouseenter', () => {
        if (!this.hoverable.matches) return;
        clearTimeout(shut);
        group.open = true;
      });

      group.addEventListener('mouseleave', () => {
        if (!this.hoverable.matches) return;
        clearTimeout(shut);
        shut = setTimeout(() => {
          group.open = false;
        }, 220);
      });
    });

    /*
     * O pai de uma lista pode ser uma pagina — o Locations e. O titulo dele
     * e um <a> dentro do <summary>, e um clique nele tanto abre o details
     * como segue o link; os browsers nao concordam em qual honram, por isso
     * a navegacao e feita aqui a mao.
     *
     * Num ecra com rato a lista ja abriu no hover, portanto o clique so
     * pode querer dizer "leva-me a pagina". Num ecra de toque nao ha hover:
     * o primeiro toque era a unica maneira de abrir a lista e levava a
     * pessoa dali para fora antes de ela ver os estados. Ai o primeiro
     * toque abre, e so o segundo — com a lista ja aberta — navega.
     *
     * Cliques com modificador ficam de fora: e assim que se abre um link
     * num separador novo.
     */
    this.root.querySelectorAll('[data-sgs-parent-link]').forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;
        if (event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const href = anchor.getAttribute('href');
        if (!href || href === '#' || href.startsWith('#')) return;

        const group = anchor.closest('details');

        if (group && !group.open && !this.hoverable.matches) {
          event.preventDefault();
          const siblings = group.parentElement
            ? group.parentElement.querySelectorAll('details')
            : [];
          siblings.forEach((other) => {
            if (other !== group) other.open = false;
          });
          group.open = true;
          return;
        }

        event.preventDefault();
        window.location.href = anchor.href;
      });
    });

    document.addEventListener('click', (event) => {
      groups.forEach((group) => {
        if (!group.contains(event.target)) group.open = false;
      });
    });
  }
}

/**
 * Bring same-shop absolute links home.
 *
 * Some menu items and some body copy point at https://<the live domain>/...
 * instead of at a path. On the live site that works; inside a preview or a
 * `theme dev` server it drops the visitor out of the theme being previewed
 * and onto the published one. This only rewrites the href in the DOM, so
 * what is served — and what a crawler reads — is untouched.
 */
function sgsKeepLinksInTheme(root) {
  const hosts = new Set(
    (root.dataset.sgsOwnHosts || '')
      .split(',')
      .map((h) => h.trim().toLowerCase())
      .filter(Boolean)
  );
  if (!hosts.size) return;

  document.querySelectorAll('a[href^="http"]').forEach((a) => {
    let url;
    try {
      url = new URL(a.href);
    } catch (err) {
      return;
    }
    if (!hosts.has(url.hostname.toLowerCase())) return;
    a.setAttribute('href', url.pathname + url.search + url.hash);
  });
}

document.querySelectorAll('[data-sgs-header]').forEach((root) => {
  new SgsHeader(root);
  sgsKeepLinksInTheme(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-journal"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsJournalBound === '1') return;
    section.dataset.sgsJournalBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-journal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-packs"] && !Shopify.designMode) return;
  try {
    
class SgsPacks {
  constructor(root) {
    this.root = root;
    this.money = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: root.dataset.currency || 'USD',
    });

    root.querySelectorAll('[data-sgs-group]').forEach((group) => this.setupGroup(group));
  }

  setupGroup(group) {
    const ui = {
      tiers: Array.from(group.querySelectorAll('[data-tier]')),
      state: group.querySelector('[data-sgs-state]'),
      opts: Array.from(group.querySelectorAll('[data-opt]')),
      line: group.querySelector('[data-sgs-line]'),
      total: group.querySelector('[data-sgs-total]'),
      save: group.querySelector('[data-sgs-save]'),
      id: group.querySelector('[data-sgs-id]'),
      formQty: group.querySelector('[data-sgs-formqty]'),
      ret: group.querySelector('[data-sgs-return]'),
      cta: group.querySelector('.sgs-packs__cta'),
    };

    if (!ui.tiers.length || !ui.opts.length) return;

    /* Packs fechados: o cartao e a escolha, e a quantidade e a dele. Nao ha
       nada a escrever, por isso nao ha escalao a deduzir. */
    ui.steps = ui.tiers
      .map((el) => ({
        el,
        qty: parseInt(el.dataset.qty, 10) || 0,
        pct: parseFloat(el.dataset.pct) || 0,
        code: el.dataset.code || '',
      }))
      .sort((a, b) => a.qty - b.qty);

    /* Abre no mais pequeno: mostrar o de 50 por omissao era pousar seis mil
       dolares em cima de quem chega. */
    ui.tier = ui.steps[0];

    ui.steps.forEach((s) => {
      s.el.addEventListener('click', () => {
        ui.tier = s;
        this.render(ui);
      });
    });

    if (ui.state) {
      ui.state.addEventListener('change', () => this.showState(ui));
    }

    ui.opts.forEach((input) => input.addEventListener('change', () => this.render(ui)));

    if (ui.state) this.showState(ui);
    else this.pickFirst(ui);

    this.render(ui);
  }

  /* Um estado de cada vez. As opcoes escondidas ficam no DOM mas nao podem
     continuar escolhidas, senao o carrinho leva o curso do estado errado. */
  showState(ui) {
    const handle = ui.state.value;

    ui.opts.forEach((input) => {
      const cell = input.closest('.sgs-packs__opt');
      const mine = input.dataset.state === handle;
      if (cell) cell.hidden = !mine;
      if (!mine && input.checked) input.checked = false;
    });

    this.pickFirst(ui);
    this.render(ui);
  }

  pickFirst(ui) {
    if (ui.opts.some((input) => input.checked && !input.closest('.sgs-packs__opt').hidden)) return;
    const first = ui.opts.find((input) => !input.closest('.sgs-packs__opt').hidden);
    if (first) first.checked = true;
  }

  render(ui) {
    const chosen = ui.opts.find((input) => input.checked);
    const tier = ui.tier;
    const qty = tier ? tier.qty : 0;

    ui.steps.forEach((s) => {
      const on = s === tier;
      s.el.classList.toggle('is-on', on);
      s.el.setAttribute('aria-pressed', String(on));
    });

    if (!chosen) {
      if (ui.cta) ui.cta.disabled = true;
      if (ui.total) ui.total.textContent = '';
      if (ui.line) ui.line.textContent = '';
      return;
    }

    if (ui.cta) ui.cta.disabled = false;

    const unit = parseInt(chosen.dataset.price, 10) || 0;
    const gross = unit * qty;
    const pct = tier ? tier.pct : 0;
    /* A conta do checkout, medida a 2026-09-21 nos tres escaloes: o desconto
       e calculado POR UNIDADE e cortado ao cent para baixo, e so depois
       multiplicado. 10 x $99.99 a 5% da $950.00 (10 x $4.99 de desconto), nao
       os $949.91 de arredondar o total. `unit * pct` fica em inteiros para o
       `floor` nao tropecar em 244.99999. */
    const offUnit = Math.floor((unit * pct) / 100);
    const net = gross - offUnit * qty;

    if (ui.line) {
      ui.line.textContent =
        qty + ' x ' + this.money.format(unit / 100) +
        (pct ? '  -  ' + pct + '% off' : '');
    }

    if (ui.total) ui.total.textContent = this.money.format(net / 100);

    if (ui.save) {
      const saved = gross - net;
      ui.save.hidden = saved <= 0;
      ui.save.textContent = 'You save ' + this.money.format(saved / 100);
    }

    if (ui.id) ui.id.value = chosen.value;
    if (ui.formQty) ui.formQty.value = String(qty);

    /* O desconto vai por codigo. Sem JS o formulario ainda leva o carrinho
       ao checkout, so que sem desconto — por isso o `return_to` e sempre
       escrito aqui, e nunca ficam os dois em desacordo. */
    if (ui.ret) {
      ui.ret.value = tier && tier.code
        ? '/discount/' + encodeURIComponent(tier.code) + '?redirect=/checkout'
        : '/checkout';
    }
  }
}

document.querySelectorAll('[data-sgs-packs]').forEach((root) => new SgsPacks(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-page-hero"] && !Shopify.designMode) return;
  try {
    
/* --sp for the drift, and the reveal on arrival. The loop runs only while
   the hero is on screen, which on a page like this means only at the top. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsPheroBound === '1') return;
    section.dataset.sgsPheroBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');
    /* On the first screen there is nothing to scroll into, so it opens on
       the next frame instead of waiting for an intersection. */
    window.requestAnimationFrame(function () {
      section.classList.add('is-in');
    });

    var running = false;
    var frame = null;

    function tick() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var p = (vh - rect.top) / (rect.height + vh);
      section.style.setProperty('--sp', Math.max(0, Math.min(1, p)).toFixed(4));
      frame = running ? window.requestAnimationFrame(tick) : null;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (running) return;
          running = true;
          frame = window.requestAnimationFrame(tick);
        } else {
          running = false;
          if (frame) window.cancelAnimationFrame(frame);
          frame = null;
        }
      });
    });

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-phero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-paths"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. Nothing here needs a frame loop: the section has no parallax
   and no counter, so an observer that fires once and then stops watching is
   the whole job. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsPathsBound === '1') return;
    section.dataset.sgsPathsBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-paths]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-pay"] && !Shopify.designMode) return;
  try {
    
/* Lets the ruler grow and counts the three figures up, once, when the
   section arrives. With no JS the marks stand at full height from the
   start and the numbers are already correct. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsPayBound === '1') return;
    section.dataset.sgsPayBound = '1';

    if (reduce.matches) {
      section.classList.add('is-in');
      return;
    }

    var counters = Array.prototype.slice.call(section.querySelectorAll('[data-pay-count]'));
    counters.forEach(function (el) {
      el.dataset.target = el.getAttribute('data-to');
      el.textContent = '0';
    });

    /* One clock for all three, so they land together instead of finishing
       in a ragged sequence. */
    function countUp() {
      if (!counters.length) return;
      var started = null;
      var span = 1500;

      function frame(now) {
        if (started === null) started = now;
        var t = Math.min(1, (now - started) / span);
        var eased = 1 - Math.pow(1 - t, 3);
        counters.forEach(function (el) {
          el.textContent = String(Math.round(eased * parseInt(el.dataset.target, 10)));
        });
        if (t < 1) window.requestAnimationFrame(frame);
      }

      window.requestAnimationFrame(frame);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          countUp();
          io.disconnect();
        });
      },
      { threshold: 0.3 }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-pay]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-process"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. Everything else is CSS. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsProcBound === '1') return;
    section.dataset.sgsProcBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { threshold: 0.1 }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-proc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-proof"] && !Shopify.designMode) return;
  try {
    
/* Sound is the default everywhere: desktop hover and the centred card on a
   phone both try to play unmuted first.

   Browsers refuse audible playback until the page has been interacted with,
   so a refusal is not treated as "play it muted, tough luck" — the clip
   starts muted and the section arms a one-shot listener for the visitor's
   first click, tap or keypress anywhere on the page, then turns the sound
   on by itself. In practice a visitor who has scrolled this far has almost
   always already tapped something. */
(function () {
  var DESKTOP = '(min-width: 990px)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Shared across sections: one gesture unlocks audio for the whole page. */
  var unlocked = false;
  var waiting = [];

  function armUnlock() {
    if (unlocked) return;
    var events = ['pointerdown', 'touchend', 'keydown', 'click'];

    function onGesture() {
      unlocked = true;
      events.forEach(function (name) {
        document.removeEventListener(name, onGesture, true);
      });
      waiting.splice(0).forEach(function (fn) {
        fn();
      });
    }

    events.forEach(function (name) {
      document.addEventListener(name, onGesture, true);
    });
  }

  function initSection(section) {
    if (section.dataset.sgsProofBound === '1') return;
    section.dataset.sgsProofBound = '1';

    var rail = section.querySelector('[data-proof-rail]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-proof-card]'));
    var desktop = window.matchMedia(DESKTOP);
    var muteAll = false; /* set only when the visitor hits the mute button */

    function videoOf(card) {
      return card.querySelector('[data-proof-video]');
    }

    function markSound(card, muted) {
      card.classList.toggle('is-muted', muted);
      var toggle = card.querySelector('[data-proof-sound]');
      if (toggle) toggle.setAttribute('aria-pressed', muted ? 'true' : 'false');
    }

    function stop(card) {
      var video = videoOf(card);
      if (!video) return;
      video.pause();
      card.classList.remove('is-playing');
    }

    function stopAll(except) {
      cards.forEach(function (card) {
        if (card !== except) stop(card);
      });
    }

    function play(card) {
      var video = videoOf(card);
      if (!video) return;

      stopAll(card);
      card.classList.add('is-playing');

      video.muted = muteAll;
      markSound(card, muteAll);

      var attempt = video.play();
      if (!attempt || typeof attempt.catch !== 'function') return;

      attempt.catch(function () {
        /* Refused because there has been no gesture yet: run it silently
           and queue the unmute for the moment there is one. */
        video.muted = true;
        markSound(card, true);
        video.play();

        if (muteAll) return;

        waiting.push(function () {
          if (muteAll || video.paused) return;
          video.muted = false;
          markSound(card, false);
        });
        armUnlock();
      });
    }

    cards.forEach(function (card) {
      var video = videoOf(card);
      var button = card.querySelector('[data-proof-play]');
      var sound = card.querySelector('[data-proof-sound]');
      var progress = card.querySelector('[data-proof-progress]');
      if (!video || !button) return;

      button.addEventListener('click', function () {
        if (video.paused) {
          play(card);
        } else {
          stop(card);
        }
      });

      if (sound) {
        sound.addEventListener('click', function (event) {
          event.stopPropagation();
          muteAll = !video.muted;
          video.muted = muteAll;
          markSound(card, muteAll);
        });
      }

      card.addEventListener('mouseenter', function () {
        if (!desktop.matches || reduce.matches) return;
        if (video.paused) play(card);
      });

      card.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        stop(card);
        video.currentTime = 0;
        if (progress) progress.style.width = '0';
      });

      video.addEventListener('timeupdate', function () {
        if (!progress || !video.duration) return;
        progress.style.width = (video.currentTime / video.duration) * 100 + '%';
      });
    });

    if (!rail) return;

    /* ── the carousel arrows (desktop only) ─────────────────────────── */
    var prev = section.querySelector('[data-proof-prev]');
    var next = section.querySelector('[data-proof-next]');

    function paintArrows() {
      if (!prev || !next) return;
      var end = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= end;
    }

    /* One press moves a full screenful, which is exactly the three cards
       that were visible — the same jump the eye expects from a grid. */
    function step(direction) {
      rail.scrollBy({
        left: direction * rail.clientWidth,
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        step(-1);
      });
      next.addEventListener('click', function () {
        step(1);
      });
      paintArrows();
    }

    /* ── phone: whichever card is centred is the one playing ────────── */
    var ticking = false;
    var onScreen = false;

    function centre() {
      if (desktop.matches || reduce.matches) return;

      /* Nada toca com a seccao fora do ecra, e isto tem de ser dito AQUI e
         nao so no observador. O `resize` la em baixo tambem chama esta
         funcao, e num telemovel o `resize` dispara quando a barra de
         endereco se esconde — ou seja, ao primeiro scroll da pagina, com o
         visitante ainda na segunda seccao, os videos comecavam a tocar la
         em baixo sem ninguem os ver. */
      if (!onScreen) return;

      var box = rail.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var winner = null;
      var best = Infinity;

      cards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < best) {
          best = d;
          winner = card;
        }
      });

      cards.forEach(function (card) {
        card.classList.toggle('is-centred', card === winner);
      });

      if (winner && !winner.classList.contains('is-playing')) play(winner);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        centre();
        paintArrows();
      });
    }

    rail.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    /* Nothing plays until the section is actually on screen, and everything
       stops the moment it leaves. */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          onScreen = entry.isIntersecting;
          if (entry.isIntersecting) {
            centre();
          } else {
            stopAll(null);
            cards.forEach(function (card) {
              card.classList.remove('is-centred');
            });
          }
        });
      },
      { threshold: 0.35 }
    );

    io.observe(section);

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', function () {
        stopAll(null);
        cards.forEach(function (card) {
          card.classList.remove('is-centred');
        });
        centre();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-sgs-proof]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-requirements"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. Everything else is CSS. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsReqBound === '1') return;
    section.dataset.sgsReqBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { threshold: 0.14 }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-req]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-role"] && !Shopify.designMode) return;
  try {
    
/* Two independent jobs in one loop.

   1. --sp: how far the section has crossed the viewport, 0 to 1. Read from
      CSS by the parallax drift. Runs on every screen size.

   2. The drum, desktop only. The cards leave the grid and become one
      rectangle in the middle of the ring; once the section is 85% on
      screen they fan out onto it and it turns, without stopping.
      Position is a single number, "rot", counted in cards: each card's
      distance from the centre is (index - rot) wrapped into [-N/2, N/2),
      which is what makes it endless — a card that leaves one edge is
      already the card arriving at the other. It is faded out at the edges,
      so the wrap is never seen. */
(function () {
  /* Era `(min-width: 990px)`: o carrossel so existia no desktop e em
     telemovel os cartoes ficavam numa grelha. O Pedro pediu o mesmo
     carrossel no telefone — um cartao ao centro e dois dos lados — por isso
     o portao passa a estar sempre aberto. O nome da variavel fica: e ele
     que continua a decidir quando se entra e sai do carrossel. */
  var DESKTOP = '(min-width: 1px)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Shape of the ring.

     The card itself was widened to grow the middle one, and SIDE keeps the
     ones level with the camera at the size they already had, so the extra
     size landed only where it was wanted. */
  /* The orbit is an oval standing on end, seen from above: narrow across
     the screen and long towards the camera. Its sharp ends are the card
     nearest the lens and the card furthest from it, so cards separate by
     going away rather than by sliding apart — they stay close together the
     whole way round, and the side ones tuck behind the middle one.

     It is not drawn as an oval. It comes out as one because both the size
     AND the sideways position are divided by distance, the way a lens does
     it: what is far sits nearer the middle of the screen, not merely
     smaller. RADIUS is how wide the oval is, SIDE is how deep — the lower
     SIDE goes, the longer the oval stands. */
  var RADIUS = 0.95;  /* orbit half-width before projection, in card widths */
  var SIDE = 0.55;    /* size of a card level with the camera */
  var DIM = 0.5;      /* wash on a card at the back */
  /* The ring moves in steps: it rests, turns a quarter, rests again. One
     card goes by every CYCLE_MS, of which TURN_MS is spent actually
     moving. For a ring that never stops instead, set TURN_MS equal to
     CYCLE_MS. Three cards are on screen at every instant.

     That is arithmetic, not luck. A card is solid across the whole front
     half of the ring and fades linearly across the back half: opacity is
     (180 - |angle|) / 90, clamped. Four cards sit 90 degrees apart, so
     whatever the position, their opacities always add up to exactly 3.
     The two halves of that crossfade are mirror images about the middle
     card — the one leaving on the left is as far gone as the one arriving
     on the right is here. The middle card is the 50% line. */
  /* 2s de cartao a cartao, pedido do Pedro (2026-09-07), no telemovel e no
     desktop — eram 4s de origem, passaram por 1,5s e ficaram aqui. A volta
     volta aos 1000ms do desenho original: a 1,5s de ciclo sobravam-lhe 500ms
     de pausa e o anel parecia nao parar nunca, mas a 2s ela cabe outra vez e
     sobra um segundo parado. E a leitura de "descansa, roda, descansa" que a
     curva easeInOut desenha.

     2026-09-20: a 2s nao dava para ler. Cada cartao leva um titulo e uma
     frase de 11 a 13 palavras, e com 1s parado so se apanhava o titulo. O
     Pedro pediu mais tempo: 3,5s parado, e logo a seguir "um bocadinho de
     nada mais rapido" — ficou em 3s parado mais a mesma volta de 1s. A volta
     nao muda, por isso o gesto e o mesmo — so o descanso e que cresce. */
  var CYCLE_MS = 4000; /* 3s parado mais a volta de 1s aqui em baixo */
  var TURN_MS = 1000;  /* quanto disso e passado a rodar */
  var OPEN_MS = 900;

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /* Slow out of a resting place, quick through the middle, slow into the
     next — the shape a hand gives a real carousel. */
  function easeInOut(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }


  function init(section) {
    if (section.dataset.sgsRoleBound === '1') return;
    section.dataset.sgsRoleBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var grid = section.querySelector('[data-role-drum]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.sgs-role__card')) : [];
    var n = cards.length;
    var desktop = window.matchMedia(DESKTOP);

    var running = false;
    var frame = null;
    var last = 0;

    var drum = false;   /* cards are on the ring */
    var open = false;   /* the fan-out has been triggered */
    var opened = 0;     /* ms since the fan-out began */
    var rot = 0;        /* position of the turn, in cards */
    var seat = 0;       /* which resting place it last settled on */
    var clock = 0;      /* ms into the current rest-and-turn cycle */

    function wrap(d) {
      var half = n / 2;
      while (d < -half) d += n;
      while (d >= half) d -= n;
      return d;
    }

    /* Called as soon as the section is watched, not when it opens: the
       cards have to be stacked into one rectangle BEFORE anyone sees them,
       otherwise they show up as a grid and then collapse, which is the
       opposite of the effect. */
    function enterDrum() {
      if (drum || !grid || n < 2) return;
      drum = true;
      open = false;
      opened = 0;
      rot = 0;
      grid.classList.add('is-drum');
      paint(0);
    }

    function leaveDrum() {
      if (!drum || !grid) return;
      drum = false;
      open = false;
      grid.classList.remove('is-drum');
      cards.forEach(function (card) {
        card.style.transform = '';
        card.style.opacity = '';
        card.style.zIndex = '';
        card.style.setProperty('--dim', '0');
      });
    }

    function paint(dt) {
      /* The ring only opens once, and only then does it start turning. */
      if (open) opened = Math.min(OPEN_MS, opened + dt);
      var spread = easeOut(opened / OPEN_MS);

      if (spread >= 1) {
        clock += dt;
        while (clock >= CYCLE_MS) {
          clock -= CYCLE_MS;
          seat += 1;
        }
        /* Rests through the front of the cycle, then turns; the turn ends
           exactly on the next seat, so the hand-off is seamless. */
        var into = clock - (CYCLE_MS - TURN_MS);
        rot = seat + (into <= 0 ? 0 : easeInOut(into / TURN_MS));
      }

      var width = cards[0].offsetWidth || 1;
      var radius = width * RADIUS * spread;
      var quarter = Math.PI / 2;

      cards.forEach(function (card, i) {
        /* Negative so the front card swings out to the left. */
        var a = -(rot + i) * quarter;

        /* +1 dead in front of the viewer, 0 at either side, -1 behind. */
        var depth = Math.cos(a);

        /* One divide by distance, used twice: on the size and on how far
           out to the side the card is drawn. Front is 1, level with the
           camera is SIDE, and the far point falls out of the same sum. */
        var pull = 1 - SIDE;
        var target = SIDE / (1 - pull * depth);
        var scale = 1 + (target - 1) * spread;
        var x = radius * Math.sin(a) * target;

        /* Solid across the front half, a straight fade across the back
           half. The pair mid-crossing always splits one card's worth of
           presence between them, which is what keeps the total at three. */
        var turn = Math.abs(Math.atan2(Math.sin(a), Math.cos(a)));
        var fade = Math.max(0, Math.min(1, (Math.PI - turn) / (Math.PI / 2)));
        var opacity = i === 0 && spread < 1 ? Math.max(fade, 1 - spread) : fade;

        card.style.transform =
          'translate3d(' + x.toFixed(1) + 'px, 0, 0) scale(' + scale.toFixed(3) + ')';
        card.style.opacity = opacity.toFixed(3);
        card.style.zIndex = String(Math.round((depth + 1) * 50));
        card.style.setProperty('--dim', (((1 - depth) / 2) * DIM * spread).toFixed(3));
      });
    }

    function tick(now) {
      var dt = last ? Math.min(64, now - last) : 16;
      last = now;

      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      var p = (vh - rect.top) / (rect.height + vh);
      section.style.setProperty('--sp', Math.max(0, Math.min(1, p)).toFixed(4));

      if (desktop.matches && n > 1) {
        if (!drum) enterDrum();
        /* 85% of the section's own height showing is the cue to fan out. */
        var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        var shown = rect.height ? visible / Math.min(rect.height, vh) : 0;
        if (!open && shown >= 0.85) open = true;
        paint(dt);
      }

      frame = running ? window.requestAnimationFrame(tick) : null;
    }

    function start() {
      if (running) return;
      running = true;
      last = 0;
      frame = window.requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      if (frame) window.cancelAnimationFrame(frame);
      frame = null;
    }

    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', function () {
        if (!desktop.matches) leaveDrum();
      });
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-in');
            start();
          } else {
            stop();
          }
        });
      },
      { rootMargin: '10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-role]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-stack"] && !Shopify.designMode) return;
  try {
    
/* Nothing here is load-bearing: without it the table is simply already
   there, fully drawn. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsStackBound === '1') return;
    section.dataset.sgsStackBound = '1';

    if (reduce.matches) {
      section.classList.add('is-in');
      return;
    }

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          io.disconnect();
        });
      },
      { threshold: 0.25 }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-stack]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-standard"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. Everything else is CSS. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsStandardBound === '1') return;
    section.dataset.sgsStandardBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { threshold: 0.12 }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-standard]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-state-intro"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsSintroBound === '1') return;
    section.dataset.sgsSintroBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-sintro]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-states"] && !Shopify.designMode) return;
  try {
    
class SgsStates {
  constructor(root) {
    this.root = root;
    this.tip = root.querySelector('[data-sgs-tip]');
    this.tipName = root.querySelector('[data-sgs-tip-name]');
    this.mapWrap = root.querySelector('.sgs-states__mapwrap');

    const cards = new Map();
    root.querySelectorAll('.sgs-strip[data-code]').forEach((card) => {
      cards.set(card.dataset.code.toUpperCase(), card);
    });

    const active = (root.dataset.active || '')
      .split(',')
      .map((code) => code.trim().toUpperCase())
      .filter(Boolean);

    active.forEach((code) => {
      const card = cards.get(code);
      const shape = root.querySelector('.sgs-map__state[data-code="' + code + '"]');
      if (!card || !shape) return;

      const label = root.querySelector('.sgs-map__label[data-code="' + code + '"]');
      const callout = root.querySelector('.sgs-map__callout[data-code="' + code + '"]');
      const name = card.querySelector('.sgs-strip__name');

      shape.classList.add('is-active');
      if (label) label.classList.add('is-active');
      if (callout) callout.classList.add('is-active');

      const on = () => {
        shape.classList.add('is-on');
        card.classList.add('is-on');
        if (label) label.classList.add('is-on');
        this.showTip(shape, name ? name.textContent.trim() : code);
      };
      const off = () => {
        shape.classList.remove('is-on');
        card.classList.remove('is-on');
        if (label) label.classList.remove('is-on');
        this.hideTip();
      };

      shape.addEventListener('mouseenter', on);
      shape.addEventListener('mouseleave', off);
      shape.addEventListener('click', () => {
        window.location.href = card.href;
      });

      card.addEventListener('mouseenter', on);
      card.addEventListener('mouseleave', off);
      card.addEventListener('focus', on);
      card.addEventListener('blur', off);
    });
  }

  showTip(shape, label) {
    if (!this.tip || !this.mapWrap) return;
    const box = shape.getBoundingClientRect();
    const wrap = this.mapWrap.getBoundingClientRect();
    if (!box.width) return;

    this.tipName.textContent = label;
    this.tip.hidden = false;
    this.tip.style.left = box.left - wrap.left + box.width / 2 + 'px';
    this.tip.style.top = box.top - wrap.top + 'px';
  }

  hideTip() {
    if (this.tip) this.tip.hidden = true;
  }
}

document.querySelectorAll('[data-sgs-states]').forEach((root) => new SgsStates(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-steps"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. Everything else is CSS. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsStepsBound === '1') return;
    section.dataset.sgsStepsBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-steps]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-story"] && !Shopify.designMode) return;
  try {
    
/* --sp for the drift on the photograph, plus the reveal. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsStoryBound === '1') return;
    section.dataset.sgsStoryBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var running = false;
    var frame = null;

    function tick() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var p = (vh - rect.top) / (rect.height + vh);
      section.style.setProperty('--sp', Math.max(0, Math.min(1, p)).toFixed(4));
      frame = running ? window.requestAnimationFrame(tick) : null;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-in');
            if (running) return;
            running = true;
            frame = window.requestAnimationFrame(tick);
          } else {
            running = false;
            if (frame) window.cancelAnimationFrame(frame);
            frame = null;
          }
        });
      },
      { rootMargin: '10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-story]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-support"] && !Shopify.designMode) return;
  try {
    
/* Reveal only — the pinning is CSS, and CSS does not stop working. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsSupportBound === '1') return;
    section.dataset.sgsSupportBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-support]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-team"] && !Shopify.designMode) return;
  try {
    
/* Reveal only. The bios are <details>, so the browser owns the toggle. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(section) {
    if (section.dataset.sgsTeamBound === '1') return;
    section.dataset.sgsTeamBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-in');
          observer.disconnect();
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-team]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-video-hero"] && !Shopify.designMode) return;
  try {
    
class SgsVideoHero {
  constructor(root) {
    this.root = root;
    this.video = root.querySelector('.sgs-hero__video');
    this.gestureCleanup = null;

    requestAnimationFrame(() => this.root.classList.add('is-shown'));

    this.measureHeader();
    window.addEventListener('resize', () => this.measureHeader());

    if (this.video) this.setupPlayback();
    this.setupPicker();
  }

  measureHeader() {
    if (!this.root.classList.contains('sgs-hero--overlap')) return;
    const header = document.querySelector('.section-header, .shopify-section-group-header-group');
    const height = header ? header.offsetHeight : 0;
    this.root.style.setProperty('--sgs-header-h', height + 'px');
  }

  setupPlayback() {
    this.video.addEventListener('playing', () => this.root.classList.add('is-playing'));

    const tryPlay = () => {
      if (!this.video.paused) return;
      const promise = this.video.play();
      if (!promise || typeof promise.then !== 'function') return;
      promise.catch(() => {
        if (this.video.paused) this.onFirstGesture(tryPlay);
      });
    };

    tryPlay();
    this.video.addEventListener('loadeddata', tryPlay);
    this.video.addEventListener('canplay', tryPlay);
    window.addEventListener('pageshow', tryPlay);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) tryPlay();
    });
  }

  onFirstGesture(callback) {
    if (this.gestureCleanup) this.gestureCleanup();
    const events = ['touchstart', 'pointerdown', 'click'];
    const handler = () => {
      this.gestureCleanup();
      callback();
    };
    this.gestureCleanup = () => {
      events.forEach((name) => document.removeEventListener(name, handler));
      this.gestureCleanup = null;
    };
    events.forEach((name) => document.addEventListener(name, handler, { once: true, passive: true }));
  }

  setupPicker() {
    const button = this.root.querySelector('[data-sgs-hero-go]');
    const error = this.root.querySelector('[data-sgs-hero-error]');
    if (!button) return;

    const select = document.getElementById(button.dataset.target);
    if (!select) return;

    const go = () => {
      if (!select.value) {
        if (error) error.hidden = false;
        select.focus();
        return;
      }
      if (error) error.hidden = true;
      window.location.href = select.value;
    };

    button.addEventListener('click', go);
    select.addEventListener('change', () => {
      if (error) error.hidden = true;
    });
    select.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') go();
    });
  }
}

document.querySelectorAll('.sgs-hero').forEach((root) => new SgsVideoHero(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    document.querySelectorAll('[data-sgs-video]').forEach(function (section) {
      if (section.dataset.sgsVideoBound) return;
      section.dataset.sgsVideoBound = '1';

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!reduced) {
        section.setAttribute('data-reveal', '');
        var reveal = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              reveal.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px' }
        );
        reveal.observe(section);
      }

      var frame = section.querySelector('[data-sgs-video-frame]');
      var video = section.querySelector('[data-sgs-video-media]');
      if (!frame || !video) return;

      var playButton = section.querySelector('[data-sgs-video-play]');
      var playLabel = section.querySelector('[data-sgs-video-label]');
      var soundButton = section.querySelector('[data-sgs-video-sound]');
      var playText = playLabel ? playLabel.textContent : 'Play video';
      // Once someone has paused it by hand, arriving back in view must not
      // start it again — an autoplay that overrules the visitor is worse than
      // no autoplay at all.
      var stopped = false;

      video.addEventListener('playing', function () {
        frame.classList.add('is-playing');
        if (playLabel) playLabel.textContent = 'Pause video';
      });

      video.addEventListener('pause', function () {
        frame.classList.remove('is-playing');
        if (playLabel) playLabel.textContent = playText;
      });

      function attempt() {
        var promise = video.play();
        if (!promise || typeof promise.then !== 'function') return;
        promise.catch(function () {
          // Sound was refused because the page has had no gesture yet: fall
          // back to muted rather than leaving a still frame.
          if (video.muted) return;
          video.muted = true;
          frame.classList.remove('is-loud');
          video.play().catch(function () {});
        });
      }

      if (playButton) {
        playButton.addEventListener('click', function () {
          if (video.paused) {
            stopped = false;
            attempt();
          } else {
            stopped = true;
            video.pause();
          }
        });
      }

      if (soundButton) {
        soundButton.addEventListener('click', function (event) {
          event.stopPropagation();
          video.muted = !video.muted;
          frame.classList.toggle('is-loud', !video.muted);
          if (video.paused) {
            stopped = false;
            attempt();
          }
        });
      }

      // Autoplay only while the section is actually being looked at, and only
      // muted — the browser refuses anything else, and a page that talks at you
      // on load is the thing everyone hates.
      var watcher = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
              if (reduced || stopped || !video.paused) return;
              video.muted = true;
              attempt();
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.4] }
      );

      watcher.observe(frame);
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-who"] && !Shopify.designMode) return;
  try {
    
/* Three jobs, one loop per section.

   1. --sp: how far the section has crossed the viewport, 0 to 1. The photo
      drift reads it from CSS.
   2. .is-in: the reveal, once.
   3. The figures count up, once, to whatever was typed in the editor. The
      typed string is the source of truth — "$1.7M+" keeps its dollar sign,
      its decimal and its plus, and only the digits move. Nobody has to fill
      in three fields to write one number, and the server-rendered text is
      already the final state for anyone without JS. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var COUNT_MS = 1400;

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /* Pulls the first number out of the label and hands back everything
     needed to rebuild it: what came before, what came after, how many
     decimals it was written with, and whether it used thousands commas. */
  function readNumber(text) {
    var match = text.match(/-?\d[\d,]*(\.\d+)?/);
    if (!match) return null;

    var raw = match[0];

    return {
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + raw.length),
      target: parseFloat(raw.replace(/,/g, '')),
      decimals: raw.indexOf('.') === -1 ? 0 : raw.split('.')[1].length,
      grouped: raw.indexOf(',') !== -1
    };
  }

  function format(shape, value) {
    var text = value.toFixed(shape.decimals);

    if (shape.grouped) {
      var parts = text.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      text = parts.join('.');
    }

    return shape.prefix + text + shape.suffix;
  }

  function init(section) {
    if (section.dataset.sgsWhoBound === '1') return;
    section.dataset.sgsWhoBound = '1';

    if (reduce.matches) return;

    section.setAttribute('data-reveal', '');

    var numbers = [];
    Array.prototype.forEach.call(section.querySelectorAll('[data-who-num]'), function (el) {
      var shape = readNumber(el.textContent.trim());
      if (shape) numbers.push({ el: el, shape: shape });
    });

    var running = false;
    var frame = null;
    var last = 0;
    var counting = false;
    var counted = 0;

    function tick(now) {
      var dt = last ? Math.min(64, now - last) : 16;
      last = now;

      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      var p = (vh - rect.top) / (rect.height + vh);
      section.style.setProperty('--sp', Math.max(0, Math.min(1, p)).toFixed(4));

      if (counting) {
        counted = Math.min(COUNT_MS, counted + dt);
        var t = easeOut(counted / COUNT_MS);

        numbers.forEach(function (item) {
          item.el.textContent = format(item.shape, item.shape.target * t);
        });

        if (counted >= COUNT_MS) counting = false;
      }

      frame = running ? window.requestAnimationFrame(tick) : null;
    }

    function start() {
      if (running) return;
      running = true;
      last = 0;
      frame = window.requestAnimationFrame(tick);
    }

    function stop() {
      running = false;
      if (frame) window.cancelAnimationFrame(frame);
      frame = null;
    }

    /* Zeroed here and not at parse time: until the section is on screen the
       page still shows the real figures, which is what a crawler, a printed
       page and a stalled script all get. */
    function beginCount() {
      if (counted > 0 || counting || numbers.length === 0) return;
      counting = true;
      numbers.forEach(function (item) {
        item.el.textContent = format(item.shape, 0);
      });
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-in');
            beginCount();
            start();
          } else {
            stop();
          }
        });
      },
      { rootMargin: '10% 0px' }
    );

    io.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-sgs-who]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-why"] && !Shopify.designMode) return;
  try {
    
/* A gaveta da tira, so em telemovel.

   Abaixo de 768px os quatro paineis nao cabem lado a lado, por isso um esta
   aberto e os outros encostados a uma lasca. De 1,5 em 1,5 segundos o aberto
   encolhe e o seguinte abre — a largura e que anima, o CSS trata da curva.

   Tres coisas que nao sao decoracao:

   - O primeiro painel ja vem com `is-open` escrito no HTML pelo Liquid.
     Assim, sem JS ou com `prefers-reduced-motion`, ve-se uma imagem parada
     e nao uma pilha de lascas vazias — e nunca ha dois abertos ao mesmo
     tempo, que era o que uma regra de recurso em CSS deixava acontecer se
     o JS demorasse a chegar.
   - O relogio so anda com a seccao no ecra. Um `setInterval` a rodar numa
     seccao que ninguem ve gasta bateria a trocar imagens para ninguem.
   - Um toque abre o painel tocado e para o relogio. Quem escolheu ficar a
     ler nao quer que a gaveta lhe feche a meio da frase. */
(function () {
  var STEP_MS = 2000;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phone = window.matchMedia('(max-width: 767px)');

  function init(section) {
    if (section.dataset.sgsWhyBound === '1') return;
    section.dataset.sgsWhyBound = '1';

    var strip = section.querySelector('[data-why-strip]');
    if (!strip) return;

    var panels = Array.prototype.slice.call(
      strip.querySelectorAll('.sgs-why__panel:not(.sgs-why__panel--edge)')
    );
    if (panels.length < 2) return;

    var at = 0;
    var timer = null;
    var held = false;   /* alguem tocou: o relogio nao volta sozinho */

    function show(i) {
      at = (i + panels.length) % panels.length;
      for (var k = 0; k < panels.length; k++) {
        panels[k].classList.toggle('is-open', k === at);
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (held || reduce.matches || !phone.matches) return;
      show(at);
      timer = setInterval(function () {
        show(at + 1);
      }, STEP_MS);
    }

    /* Fora do telemovel a tira volta a ser a do desktop: as classes saem,
       senao uma delas ficava a mandar numa largura que ja nao existe. */
    function leave() {
      stop();
      for (var k = 0; k < panels.length; k++) {
        panels[k].classList.remove('is-open');
      }
    }

    panels.forEach(function (panel, i) {
      panel.addEventListener('click', function () {
        if (!phone.matches || reduce.matches) return;
        held = true;
        stop();
        show(i);
      });
    });

    /* Arranca ja, e o observador so PAUSA e retoma. Ao contrario, ficava
       refem dele: se nao houver `IntersectionObserver`, se a seccao estiver
       dentro de um iframe que o browser nao considera pintado, ou se o
       callback tardar, a gaveta nunca abria e ficava uma pilha de lascas.
       O pior que acontece assim e o relogio andar uns instantes com a
       seccao fora do ecra, ate o observador dizer que nao esta la. */
    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) start();
          else stop();
        }
      }, { threshold: 0.2 }).observe(section);
    }

    if (typeof phone.addEventListener === 'function') {
      phone.addEventListener('change', function () {
        if (phone.matches) start();
        else leave();
      });
    }
  }

  function boot() {
    var all = document.querySelectorAll('[data-sgs-why]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
